import api from "@/lib/axios"
import { useQuery } from "@tanstack/react-query"
import { Link, useLocation, useSearchParams } from "react-router-dom"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"

const listMenu = [
  {
    name: "Users Elearning",
    path: "/operator-pasca/users-elearning",
  },
  {
    name: "Group Elearning",
    path: "/operator-pasca/groups-elearning",
  },
  {
    name: "Nilai Elearning",
    path: "/operator-pasca/nilai-elearning",
  },
]

const getListGroupElearning = async (
  page: string,
  limit: string,
  searchQuery: string
) => {
  const response = await api.get(
    `/operator-pasca/user-elearning/index-group?page=${page}${
      limit ? `&limit=${limit}` : ""
    }${searchQuery ? `&search=${searchQuery}` : ""}`,
    {
      withCredentials: true,
    }
  )
  return response.data?.data
}

export default function GroupsElearningPage() {
  const [searchParams] = useSearchParams()
  const pageParams = searchParams.get("page") || 1
  const limitParams = searchParams.get("limit")
  const searchQueryParams = searchParams.get("search")
  const { pathname } = useLocation()

  const { data, isPending } = useQuery({
    queryKey: [
      "listGroupElearning",
      pageParams,
      limitParams,
      searchQueryParams,
    ],
    queryFn: () =>
      getListGroupElearning(
        pageParams as string,
        limitParams as string,
        searchQueryParams as string
      ),
  })

  return (
    <div>
      <div className="rounded-full border overflow-hidden flex w-fit">
        {listMenu.map((menu, index) => {
          const active = menu.path === pathname
          return (
            <Link
              key={index}
              to={menu.path}
              className={`py-2 px-3  ${
                active
                  ? `bg-black text-white ${
                      index === 0
                        ? "rounded-r-full"
                        : index === listMenu.length
                        ? "rounded-l-full"
                        : "rounded-full"
                    }`
                  : "hover:bg-secondary cursor-pointer"
              }`}
            >
              <span className="font-semibold text-sm">{menu.name}</span>
            </Link>
          )
        })}
      </div>

      <DataTable
        data={data?.data || []}
        paginationData={data}
        columns={columns}
        isPending={isPending}
      />
    </div>
  )
}
